import { type ReactNode, useState } from "react";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { wagmiConfig } from "config/wagmi";

import { WagmiProvider } from "wagmi";

import { DEFAULT_STALE_TIME_MS } from "shared/constants/time";

interface Web3ProviderProps {
	children: ReactNode;
}

export function Web3Provider({ children }: Web3ProviderProps): ReactNode {
	// Create QueryClient inside component to avoid SSR/Fast Refresh issues
	const [queryClient] = useState(
		() =>
			new QueryClient({
				defaultOptions: {
					queries: {
						staleTime: DEFAULT_STALE_TIME_MS,
						retry: 1
					}
				}
			})
	);

	return (
		<WagmiProvider config={wagmiConfig}>
			<QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
		</WagmiProvider>
	);
}
